import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MDMService } from '../services/mdmService.service';
@Component({
    selector: 'adminPage',
    templateUrl: 'adminPage.component.html'
})

export class AdminPage implements OnInit {
    public accessDenied: boolean = false;
    public mainPage: boolean = true;

    constructor(public router: Router, public adminService: MDMService) {

    }

    ngOnInit() {
        this.adminService.roleCheck().then(() => {
            if (this.adminService.isBIAdmin) {
                this.router.navigate(['biAdmin/wizard']);
            } else {
                this.accessDenied = true;
            }
        });
    }

    enableActive(activeClass) {
        if (activeClass == 'uom')
            this.router.navigate(['biAdmin/uom']);

        if (activeClass == 'scope')
            this.router.navigate(['biAdmin/scope']);

        if (activeClass == 'dimension')
            this.router.navigate(['biAdmin/dimension']);

        if (activeClass == 'measure')
            this.router.navigate(['biAdmin/measure']);

        if (activeClass == 'dataSource')
            this.router.navigate(['biAdmin/dataSource']);

        if (activeClass == 'valueStream')
            this.router.navigate(['biAdmin/valueStream']);

        if (activeClass == 'cube')
            this.router.navigate(['biAdmin/cube']);

        if (activeClass == 'recordFormat')
            this.router.navigate(['biAdmin/recordFormat']);

        if (activeClass == 'dataEngine')
            this.router.navigate(['biAdmin/dataEngine']);

        if (activeClass == 'pageAuthorization')
            this.router.navigate(['biAdmin/pageAuthorization']);

        if (activeClass == 'dimLvlPermissions')
            this.router.navigate(['biAdmin/dimLvlPermissions']);

        if (activeClass == 'target')
            this.router.navigate(['biAdmin/target']);

        if (activeClass == 'tenantConfiguration')
            this.router.navigate(['biAdmin/tenantConfiguration']);

    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/adminPage.component.ts